import type { NavigationStep } from '../../../components/layout';
import { AppLanguage, getPreferredLanguage } from '../../../i18n/language';
import { getLabelingTemplate } from '../../../i18n/templates/labeling';

// Cache for label steps to avoid repeated async calls
const labelStepsCache: Partial<Record<AppLanguage, NavigationStep[]>> = {};

/**
 * Get navigation steps for the labeling (shipping) module
 * Only includes Purchase and Orders (Finance and Admin moved to other modules)
 * Cached to improve performance
 */
export async function getLabelSteps(
    language: AppLanguage = getPreferredLanguage(),
): Promise<NavigationStep[]> {
    const text = getLabelingTemplate(language);

    // Return cached steps if available
    if (labelStepsCache[language]) {
        return labelStepsCache[language] as NavigationStep[];
    }

    // Only Purchase and Orders - Finance and Admin are now in separate modules
    const steps: NavigationStep[] = [
        { id: 1, title: text.nav.purchase, href: "/label-management" },
        { id: 2, title: text.nav.orders, href: "/labeling-orderHistory" },
    ];

    // Cache the result
    labelStepsCache[language] = steps;
    return steps;
}

// Clear label steps cache when needed (e.g., on logout or role change)
export function clearLabelStepsCache() {
    Object.keys(labelStepsCache).forEach((key) => {
        delete labelStepsCache[key as AppLanguage];
    });
}
